import { render, staticRenderFns } from "./JobRecentTime.vue?vue&type=template&id=165794c2&scoped=true&"
import script from "./JobRecentTime.vue?vue&type=script&lang=js&"
export * from "./JobRecentTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165794c2",
  null
  
)

export default component.exports